import * as signalR from "@microsoft/signalr";
import { apiFetch } from "./api";

export interface NotificationDto {
  id: number;
  typeCode: string;
  title: string;
  body: string;
  linkUrl: string | null;
  createdOnUtc: string;
  readOnUtc: string | null;
}

export interface NotificationListResult {
  items: NotificationDto[];
  unreadCount: number;
}

export const notificationKeys = {
  list: ["notifications", "list"] as const,
};

export const notifications = {
  list: () => apiFetch<NotificationListResult>(`/api/notifications?unreadOnly=true`),
  markRead: (id: number) => apiFetch<void>(`/api/notifications/${id}/read`, { method: "POST" }),
  markAllRead: () => apiFetch<{ marked: number }>(`/api/notifications/read-all`, { method: "POST" }),
};

export function buildNotificationHubConnection(
  getAccessToken: () => Promise<string | null>,
): signalR.HubConnection {
  return new signalR.HubConnectionBuilder()
    .withUrl("/hubs/notifications", {
      accessTokenFactory: async () => (await getAccessToken()) ?? "",
    })
    .withAutomaticReconnect()
    .build();
}
